module.exports = __webpack_public_path__ + "static/media/play-circle.a47c56ff.svg";